import { defineMessages } from '@sm/intl';

const COPY = defineMessages({
  SIGN_UP_CALLOUT_SUB_HEADER: {
    id: 'EnterpriseThankYou.copy.SignUpCalloutSubHeader',
    defaultMessage:
      'Gather opinions from customers, employees, prospects, and more. Use your insights to make better, data-driven decisions.',
    description:
      "[Type: Header][Vis: high] - The Hero's subheader. A value proposition, giving a clear example of what they can get if they fill out the form below.",
  },
  POWERED_BY_TEXT: {
    id: 'EnterpriseThankYou.copy.PoweredByText',
    defaultMessage: 'Powered by',
    description:
      '[Type: Label][Vis: med] - This figure of speech is used to introduce and display the SurveyMonkey Logo',
  },
  THANK_YOU: {
    id: 'EnterpriseThankYou.copy.EnterpriseThankYouMessage',
    defaultMessage: 'Thank you for taking this survey',
    description:
      '[Type: Header][vis: high] - Header message on webpage. Used on a Nonbranded webpage to say thank you to survey respondents and signal the end of the survey.',
  },
  LOGO_PLACEHOLDER: {
    id: 'EnterpriseThankYou.copy.EnterpriseLogoPlaceholder',
    defaultMessage: 'Logo',
    description: '[Type: LogoText][Vis: low] - Logo placeholder text for a page header.',
  },
});

export default COPY;
